var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZyk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6448 16.3332C45.7701 15.6181 45.7374 14.8843 45.5489 14.1832C45.3604 13.4821 45.0208 12.8307 44.5539 12.2748C44.0869 11.719 43.504 11.272 42.846 10.9654C42.1879 10.6587 41.4707 10.4998 40.7448 10.4998H15.2554C14.5295 10.4998 13.8123 10.6587 13.1542 10.9654C12.4962 11.272 11.9132 11.719 11.4463 12.2748C10.9794 12.8307 10.6397 13.4821 10.4513 14.1832C10.2628 14.8843 10.2301 15.6181 10.3554 16.3332M40.8334 10.4998C40.8988 9.89317 40.9338 9.59217 40.9338 9.3425C40.9363 8.18912 40.5116 7.07566 39.7416 6.21692C38.9716 5.35818 37.9109 4.815 36.7641 4.69217C36.5168 4.6665 36.2134 4.6665 35.6068 4.6665H20.3934C19.7868 4.6665 19.4811 4.6665 19.2338 4.69217C18.0869 4.815 17.0262 5.35818 16.2562 6.21692C15.4863 7.07566 15.0616 8.18912 15.0641 9.3425C15.0641 9.59217 15.0968 9.8955 15.1644 10.4998",
    stroke: "#354764",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 42H21",
    stroke: "#354764",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56278 32.1833C4.51978 24.8007 3.99945 21.1117 6.21145 18.72C8.42345 16.333 12.3621 16.333 20.2348 16.333H35.7655C43.6381 16.333 47.5768 16.333 49.7888 18.7223C52.0008 21.1117 51.4781 24.8007 50.4375 32.1833L49.4528 39.1833C48.6361 44.97 48.2278 47.8657 46.1348 49.5993C44.0418 51.333 40.9548 51.333 34.7785 51.333H21.2218C15.0478 51.333 11.9585 51.333 9.86545 49.5993C7.77245 47.8657 7.36412 44.9723 6.54745 39.1833L5.56278 32.1833Z",
    stroke: "#354764",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZyk);
export default __webpack_public_path__ + "static/media/icon-zyk.1fd6e38ab47587f2aa9fb1570a8a1a08.svg";
export { ForwardRef as ReactComponent };